<div class="step-container">
  <ng-template #labelFive>{{ getTranslation('educationWork.title') }}</ng-template>
  <div class="step-title">
    {{ isEditable ? getTranslation('educationWork.title') : getTranslation('educationWork.blockedForEdit') }}
    <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
  </div>

  <form [formGroup]="educationaAndworkExperienceForm">
    <!-- Debug JSON (can be removed in production) -->
    <div *ngIf="isJsonShow">
      <span>{{ educationaAndworkExperienceForm.value | json }}</span>
    </div>

 

    <!-- Has Education Question -->
    <div class="form-group mb-4">
      <div class="row">
        <label class="form-label col-md-5 mb-0" [ngClass]="{'text-danger': educationaAndworkExperienceForm.controls['HasEducation'].invalid && submitted}">
          {{ getTranslation('educationWork.hasEducation') }} <span class="text-danger">*</span>
        </label>
        <div class="col-md-4 d-flex align-items-center">
          <label class="mr-5">
            <input type="radio" class="form-check-input" formControlName="HasEducation" value="Yes" class="me-2"> 
            {{ getTranslation('common.yes') }}
          </label>
          <label>
            <input type="radio" class="form-check-input" formControlName="HasEducation" value="No"> 
            {{ getTranslation('common.no') }}
          </label>
        </div>
      </div>
      <div *ngIf="submitted && educationaAndworkExperienceForm.controls['HasEducation'].invalid" class="text-danger small mt-1">
        {{ getTranslation('validation.requiredField') }}
      </div>
    </div>

    <!-- Educational Background Section -->
    <div class="table-section" *ngIf="educationaAndworkExperienceForm.get('HasEducation')?.value === 'Yes'">
      <h3 class="section-title">{{ getTranslation('educationWork.educationalBackground') }}</h3>
      <p class="subheader-text mb-3"><em>Begin with the most recent.</em></p>
      
      <!-- Desktop Table View -->
      <div class="table-container d-none d-md-block">
        <table class="data-table">
          <thead>
            <tr>
              <th>{{ getTranslation('educationWork.degreeDiploma') }}</th>
              <th>{{ getTranslation('educationWork.fieldOfStudySpecialization') }}</th>
              <th>{{ getTranslation('educationWork.university') }}</th>
              <th>{{ getTranslation('educationWork.yearOfCompletion') }}</th>
              <th>{{ getTranslation('educationWork.action') }}</th>
            </tr>
          </thead>
          <tbody formArrayName="UserEducation">
            <tr *ngFor="let education of educationalFormArray.controls; let i = index" [formGroupName]="i">
              <td>
                <ng-select 
                  [items]="degreeOptions" 
                  [searchable]="true"
                  formControlName="DegreeName" 
                  bindLabel="name" 
                  bindValue="name"
                  [placeholder]="getTranslation('educationWork.enterDegreeDiploma')"
                  [ngClass]="{'is-invalid': ((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('DegreeName')?.invalid}"
                  class="custom-ng-select">
                </ng-select>
                <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('DegreeName')?.invalid" class="text-danger small">
                  <div *ngIf="education.get('DegreeName')?.errors?.['required']">{{ getTranslation('validation.degreeDiplomaRequired') }}</div>
                  <div *ngIf="education.get('DegreeName')?.errors?.['maxlength']">{{ getTranslation('validation.degreeDiplomaMaxLength') }}</div>
                </div>
              </td>
              <td>
                <input type="text" formControlName="SpecializationName" class="form-control" 
                       [ngClass]="{'is-invalid': ((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('SpecializationName')?.invalid}"
                       [placeholder]="getTranslation('educationWork.enterFieldOfStudy')" maxlength="50">
                <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('SpecializationName')?.invalid" class="text-danger small">
                  <div *ngIf="education.get('SpecializationName')?.errors?.['required']">{{ getTranslation('validation.fieldOfStudyRequired') }}</div>
                  <div *ngIf="education.get('SpecializationName')?.errors?.['maxlength']">{{ getTranslation('validation.fieldOfStudyMaxLength') }}</div>
                </div>
              </td>
              <td>
                <input type="text" formControlName="University" class="form-control" 
                       [ngClass]="{'is-invalid': ((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('University')?.invalid}"
                       [placeholder]="getTranslation('educationWork.enterUniversity')" maxlength="50">
                <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('University')?.invalid" class="text-danger small">
                  <div *ngIf="education.get('University')?.errors?.['required']">{{ getTranslation('validation.universityRequired') }}</div>
                  <div *ngIf="education.get('University')?.errors?.['maxlength']">{{ getTranslation('validation.universityMaxLength') }}</div>
                </div>
              </td>
              <td>
                <app-custome-year-picker 
                  formControlName="YearCompleted"
                  [placeholder]="getTranslation('common.yearPlaceholder')">
                </app-custome-year-picker>
                <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('YearCompleted')?.errors" class="text-danger small">
                  <div *ngIf="education.get('YearCompleted')?.errors?.['required']">{{ getTranslation('validation.yearRequired') }}</div>
                  <div *ngIf="education.get('YearCompleted')?.errors?.['invalidYearLength']">{{ getTranslation('validation.yearInvalidLength') }}</div>
                  <div *ngIf="education.get('YearCompleted')?.errors?.['invalidYearFormat']">{{ getTranslation('validation.yearInvalidFormat') }}</div>
                </div>
              </td>
              <td class="action-cell">
                <button type="button" class="btn btn-danger btn-sm" (click)="removeEducationRow(i)" [disabled]="educationalFormArray.length === 1">
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile Card View -->
      <div class="mobile-cards d-md-none" formArrayName="UserEducation">
        <div *ngFor="let education of educationalFormArray.controls; let i = index" [formGroupName]="i" class="education-card mb-3 p-3 border rounded">
          <div class="row gx-2">
            <!-- Sr No -->
            <div class="col-12 mb-3">
              <label class="form-label fw-bold">{{ getTranslation('educationWork.educationNumber') }}{{ i + 1 }}</label>
            </div>

            <!-- Degree / Diploma -->
            <div class="col-12 mb-3">
              <label class="form-label">{{ getTranslation('educationWork.degreeDiploma') }} <span class="text-danger">*</span></label>
              <ng-select 
                [items]="degreeOptions" 
                [searchable]="true"
                formControlName="DegreeName" 
                bindLabel="name" 
                bindValue="name"
                [placeholder]="getTranslation('educationWork.enterDegreeDiploma')"
                [ngClass]="{'is-invalid': ((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('DegreeName')?.invalid}"
                class="custom-ng-select">
              </ng-select>
              <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('DegreeName')?.invalid" class="text-danger small">
                <div *ngIf="education.get('DegreeName')?.errors?.['required']">{{ getTranslation('validation.degreeDiplomaRequired') }}</div>
                <div *ngIf="education.get('DegreeName')?.errors?.['maxlength']">{{ getTranslation('validation.degreeDiplomaMaxLength') }}</div>
              </div>
            </div>

            <!-- Field of Study / Specialization -->
            <div class="col-12 mb-3">
              <label class="form-label">{{ getTranslation('educationWork.fieldOfStudySpecialization') }} <span class="text-danger">*</span></label>
              <input type="text" formControlName="SpecializationName" class="form-control" 
                     [ngClass]="{'is-invalid': ((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('SpecializationName')?.invalid}"
                     [placeholder]="getTranslation('educationWork.enterFieldOfStudy')" maxlength="50">
              <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('SpecializationName')?.invalid" class="text-danger small">
                <div *ngIf="education.get('SpecializationName')?.errors?.['required']">{{ getTranslation('validation.fieldOfStudyRequired') }}</div>
                <div *ngIf="education.get('SpecializationName')?.errors?.['maxlength']">{{ getTranslation('validation.fieldOfStudyMaxLength') }}</div>
              </div>
            </div>

            <!-- University -->
            <div class="col-12 mb-3">
              <label class="form-label">{{ getTranslation('educationWork.university') }} <span class="text-danger">*</span></label>
              <input type="text" formControlName="University" class="form-control" 
                     [ngClass]="{'is-invalid': ((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('University')?.invalid}"
                     [placeholder]="getTranslation('educationWork.enterUniversity')" maxlength="50">
              <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('University')?.invalid" class="text-danger small">
                <div *ngIf="education.get('University')?.errors?.['required']">{{ getTranslation('validation.universityRequired') }}</div>
                <div *ngIf="education.get('University')?.errors?.['maxlength']">{{ getTranslation('validation.universityMaxLength') }}</div>
              </div>
            </div>

            <!-- Year of Completion -->
            <div class="col-12 mb-3">
              <label class="form-label">{{ getTranslation('educationWork.yearOfCompletion') }} <span class="text-danger">*</span></label>
              <app-custome-year-picker 
                formControlName="YearCompleted"
                [placeholder]="getTranslation('common.yearPlaceholder')">
              </app-custome-year-picker>
              <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || education.touched) && education.get('YearCompleted')?.errors" class="text-danger small">
                <div *ngIf="education.get('YearCompleted')?.errors?.['required']">{{ getTranslation('validation.yearRequired') }}</div>
                <div *ngIf="education.get('YearCompleted')?.errors?.['invalidYearLength']">{{ getTranslation('validation.yearInvalidLength') }}</div>
                <div *ngIf="education.get('YearCompleted')?.errors?.['invalidYearFormat']">{{ getTranslation('validation.yearInvalidFormat') }}</div>
              </div>
            </div>

            <!-- Action Button -->
            <div class="col-12 mb-3">
              <button type="button" class="btn btn-outline-danger btn-sm w-100" (click)="removeEducationRow(i)" [disabled]="educationalFormArray.length === 1">
                <i class="fas fa-trash me-1"></i>{{ getTranslation('educationWork.removeEducation') }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="add-row-section" *ngIf="!isPreviewMode">
        <button type="button" class="btn btn-primary btn-sm" 
                (click)="addEducationRow()" 
                [disabled]="!isLastEducationRowComplete() || hasEducationYearValidationErrors()"
                [title]="getEducationAddButtonTooltip()">
          <i class="fas fa-plus"></i> {{ getTranslation('educationWork.addEducation') }}
        </button>
      </div>

      <!-- Validation Error for Education -->
      <div *ngIf="submitted && educationaAndworkExperienceForm.get('HasEducation')?.value === 'Yes' && !hasValidEducationData()" class="validation-error">
        <i class="fas fa-exclamation-triangle"></i>
        {{ getTranslation('educationWork.atLeastOneEducationRequired') }}
      </div>
    </div>

    <!-- Has Work Experience Question -->
    <div class="form-group mb-4">
      <div class="row">
        <label class="form-label col-md-5 mb-0" [ngClass]="{'text-danger': educationaAndworkExperienceForm.controls['HasWorkExperience'].invalid && submitted}">
          {{ getTranslation('educationWork.hasWorkExperience') }} <span class="text-danger">*</span>
        </label>
        <div class="col-md-4 d-flex align-items-center">
          <label class="mr-5">
            <input type="radio" class="form-check-input" formControlName="HasWorkExperience" value="Yes" class="me-2"> 
            {{ getTranslation('common.yes') }}
          </label>
          <label>
            <input type="radio" class="form-check-input" formControlName="HasWorkExperience" value="No"> 
            {{ getTranslation('common.no') }}
          </label>
        </div>
      </div>
      <div *ngIf="submitted && educationaAndworkExperienceForm.controls['HasWorkExperience'].invalid" class="text-danger small mt-1">
        {{ getTranslation('validation.requiredField') }}
      </div>
    </div>

    <!-- Work Experience Section -->
    <div class="table-section" *ngIf="educationaAndworkExperienceForm.get('HasWorkExperience')?.value === 'Yes'">
      <h3 class="section-title">{{ getTranslation('educationWork.workExperience') }}</h3>
      <p class="subheader-text mb-3"><em>Begin with the most recent. If no work experience, write 'none'.</em></p>
      
      <!-- Desktop Table View -->
      <div class="table-container d-none d-md-block">
        <table class="data-table">
          <thead>
            <tr>
              <th>{{ getTranslation('educationWork.nameOfCompany') }}</th>
              <th>{{ getTranslation('educationWork.designationJobTitle') }}</th>
              <th >{{ getTranslation('educationWork.from') }}</th>
              <th>{{ getTranslation('educationWork.to') }}</th>
              <th>{{ getTranslation('educationWork.fieldTrade') }} <small class="d-block text-muted" style="font-weight: normal; font-size: 0.75rem;">(E.g. Sales, IT, HR, Finance, etc.)</small></th>
              <th>{{ getTranslation('educationWork.action') }}</th>
            </tr>
          </thead>
          <tbody formArrayName="UserWorkExperience">
            <tr *ngFor="let work of workExperienceFormArray.controls; let i = index" [formGroupName]="i">
              <td>
                <input type="text" formControlName="CompanyName" class="form-control" 
                       [ngClass]="{'is-invalid': ((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched) && work.get('CompanyName')?.invalid}"
                       [placeholder]="getTranslation('educationWork.enterCompanyName')" maxlength="50">
                <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched) && work.get('CompanyName')?.invalid" class="text-danger small">
                  <div *ngIf="work.get('CompanyName')?.errors?.['required']">{{ getTranslation('validation.companyNameRequired') }}</div>
                  <div *ngIf="work.get('CompanyName')?.errors?.['maxlength']">{{ getTranslation('validation.companyNameMaxLength') }}</div>
                </div>
              </td>
              <td>
                <input type="text" formControlName="JobDesignation" class="form-control" 
                       [ngClass]="{'is-invalid': ((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched) && work.get('JobDesignation')?.invalid}"
                       [placeholder]="getTranslation('educationWork.enterJobDesignation')" maxlength="50">
                <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched) && work.get('JobDesignation')?.invalid" class="text-danger small">
                  <div *ngIf="work.get('JobDesignation')?.errors?.['required']">{{ getTranslation('validation.designationRequired') }}</div>
                  <div *ngIf="work.get('JobDesignation')?.errors?.['maxlength']">{{ getTranslation('validation.designationMaxLength') }}</div>
                </div>
              </td>
              <td style="text-align: center;">
                <app-custome-year-picker
                  formControlName="JobStartDate"
                  [placeholder]="getTranslation('educationWork.from')">
                </app-custome-year-picker>
                <div *ngIf="(((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched)) && work.get('JobStartDate')?.errors" class="text-danger small">
                  <div *ngIf="work.get('JobStartDate')?.errors?.['required']">{{ getTranslation('validation.fromYearRequired') }}</div>
                  <div *ngIf="work.get('JobStartDate')?.errors?.['invalidYearLength']">{{ getTranslation('validation.fromYearInvalidLength') }}</div>
                  <div *ngIf="work.get('JobStartDate')?.errors?.['invalidYearFormat']">{{ getTranslation('validation.fromYearInvalidFormat') }}</div>
                  <div *ngIf="work.get('JobStartDate')?.errors?.['yearFuture']">{{ getTranslation('validation.fromYearFuture') }}</div>
                </div>
                <div *ngIf="(((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched)) && work.errors" class="text-danger small">
                  <div *ngIf="work.errors?.['yearFuture']">{{ getTranslation('validation.yearsFuture') }}</div>
                  <div *ngIf="work.errors?.['invalidYearRange']">{{ getTranslation('validation.invalidYearRange') }}</div>
                </div>
              </td>
              <td style="text-align: center;">
                <app-custome-year-picker
                  formControlName="JobEndDate"
                  [placeholder]="getTranslation('educationWork.to')">
                </app-custome-year-picker>
                <div *ngIf="(((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched)) && work.get('JobEndDate')?.errors" class="text-danger small">
                  <div *ngIf="work.get('JobEndDate')?.errors?.['required']">{{ getTranslation('validation.toYearRequired') }}</div>
                  <div *ngIf="work.get('JobEndDate')?.errors?.['invalidYearFormat']">{{ getTranslation('validation.toYearInvalidFormat') }}</div>
                  <div *ngIf="work.get('JobEndDate')?.errors?.['invalidYearLength']">{{ getTranslation('validation.toYearInvalidLength') }}</div>
                  <div *ngIf="work.get('JobEndDate')?.errors?.['yearFuture']">{{ getTranslation('validation.toYearFuture') }}</div>
                </div>
              </td>
              <td>
                <input type="text" formControlName="FieldTradeName" class="form-control" 
                       [ngClass]="{'is-invalid': ((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched) && work.get('FieldTradeName')?.invalid}"
                       [placeholder]="getTranslation('educationWork.fieldTradeExample')" maxlength="50">
                <!-- <small class="form-text text-muted">E.g. Sales, IT, HR, Finance, etc.</small> -->
                <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched) && work.get('FieldTradeName')?.invalid" class="text-danger small">
                  <div *ngIf="work.get('FieldTradeName')?.errors?.['required']">{{ getTranslation('validation.fieldTradeRequired') }}</div>
                  <div *ngIf="work.get('FieldTradeName')?.errors?.['maxlength']">{{ getTranslation('validation.fieldTradeMaxLength') }}</div>
                </div>
              </td>
              <td class="action-cell">
                <button type="button" class="btn btn-danger btn-sm" (click)="removeWorkRow(i)" [disabled]="workExperienceFormArray.length === 1">
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile Card View -->
      <div class="mobile-cards d-md-none" formArrayName="UserWorkExperience">
        <div *ngFor="let work of workExperienceFormArray.controls; let i = index" [formGroupName]="i" class="work-card mb-3 p-3 border rounded">
          <div class="row gx-2">
            <!-- Sr No -->
            <div class="col-12 mb-3">
              <label class="form-label fw-bold">{{ getTranslation('educationWork.workExperienceNumber') }}{{ i + 1 }}</label>
            </div>

            <!-- Company Name -->
            <div class="col-12 mb-3">
              <label class="form-label">{{ getTranslation('educationWork.nameOfCompany') }} <span class="text-danger">*</span></label>
              <input type="text" formControlName="CompanyName" class="form-control" 
                     [ngClass]="{'is-invalid': ((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched) && work.get('CompanyName')?.invalid}"
                     [placeholder]="getTranslation('educationWork.enterCompanyName')" maxlength="50">
              <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched) && work.get('CompanyName')?.invalid" class="text-danger small">
                <div *ngIf="work.get('CompanyName')?.errors?.['required']">{{ getTranslation('validation.companyNameRequired') }}</div>
                <div *ngIf="work.get('CompanyName')?.errors?.['maxlength']">{{ getTranslation('validation.companyNameMaxLength') }}</div>
              </div>
            </div>

            <!-- Job Designation -->
            <div class="col-12 mb-3">
              <label class="form-label">{{ getTranslation('educationWork.designationJobTitle') }} <span class="text-danger">*</span></label>
              <input type="text" formControlName="JobDesignation" class="form-control" 
                     [ngClass]="{'is-invalid': ((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched) && work.get('JobDesignation')?.invalid}"
                     [placeholder]="getTranslation('educationWork.enterJobDesignation')" maxlength="50">
              <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched) && work.get('JobDesignation')?.invalid" class="text-danger small">
                <div *ngIf="work.get('JobDesignation')?.errors?.['required']">{{ getTranslation('validation.designationRequired') }}</div>
                <div *ngIf="work.get('JobDesignation')?.errors?.['maxlength']">{{ getTranslation('validation.designationMaxLength') }}</div>
              </div>
            </div>

            <!-- From - To Years -->
            <div class="col-12 mb-3">
              <div class="row gx-2">
                <div class="col-6">
                  <label class="form-label">{{ getTranslation('educationWork.from') }} <span class="text-danger">*</span></label>
                </div>
                <div class="col-6">
                  <label class="form-label">{{ getTranslation('educationWork.to') }} <span class="text-danger">*</span></label>
                </div>
              </div>
              <div class="row gx-2">
                <div class="col-6">
                  <app-custome-year-picker
                    formControlName="JobStartDate"
                    [placeholder]="getTranslation('educationWork.from')">
                  </app-custome-year-picker>
                </div>
                <div class="col-6">
                  <app-custome-year-picker
                    formControlName="JobEndDate"
                    [placeholder]="getTranslation('educationWork.to')">
                  </app-custome-year-picker>
                </div>
              </div>
              <div *ngIf="(((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched)) && (work.get('JobStartDate')?.errors || work.get('JobEndDate')?.errors || work.errors)" class="text-danger small">
                <div *ngIf="work.get('JobStartDate')?.errors?.['required']">{{ getTranslation('validation.fromYearRequired') }}</div>
                <div *ngIf="work.get('JobStartDate')?.errors?.['invalidYearLength']">{{ getTranslation('validation.fromYearInvalidLength') }}</div>
                <div *ngIf="work.get('JobStartDate')?.errors?.['invalidYearFormat']">{{ getTranslation('validation.fromYearInvalidFormat') }}</div>
                <div *ngIf="work.get('JobStartDate')?.errors?.['yearFuture']">{{ getTranslation('validation.fromYearFuture') }}</div>
                <div *ngIf="work.get('JobEndDate')?.errors?.['required']">{{ getTranslation('validation.toYearRequired') }}</div>
                <div *ngIf="work.get('JobEndDate')?.errors?.['invalidYearFormat']">{{ getTranslation('validation.toYearInvalidFormat') }}</div>
                <div *ngIf="work.get('JobEndDate')?.errors?.['invalidYearLength']">{{ getTranslation('validation.toYearInvalidLength') }}</div>
                <div *ngIf="work.get('JobEndDate')?.errors?.['yearFuture']">{{ getTranslation('validation.toYearFuture') }}</div>
                <!-- Form group level validation errors -->
                <div *ngIf="work.errors?.['yearFuture']">{{ getTranslation('validation.yearsFuture') }}</div>
                <div *ngIf="work.errors?.['invalidYearRange']">{{ getTranslation('validation.invalidYearRange') }}</div>
              </div>
            </div>

            <!-- Field / Trade -->
            <div class="col-12 mb-3">
              <label class="form-label">{{ getTranslation('educationWork.fieldTrade') }} <span class="text-danger">*</span></label>
              <input type="text" formControlName="FieldTradeName" class="form-control" 
                     [ngClass]="{'is-invalid': ((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched) && work.get('FieldTradeName')?.invalid}"
                     [placeholder]="getTranslation('educationWork.fieldTradeExample')" maxlength="50">
              <!-- <small class="form-text text-muted">E.g. Sales, IT, HR, Finance, etc.</small> -->
              <div *ngIf="((submitted && lastSubmitMode === SaveMode.SAVE) || work.touched) && work.get('FieldTradeName')?.invalid" class="text-danger small">
                <div *ngIf="work.get('FieldTradeName')?.errors?.['required']">{{ getTranslation('validation.fieldTradeRequired') }}</div>
                <div *ngIf="work.get('FieldTradeName')?.errors?.['maxlength']">{{ getTranslation('validation.fieldTradeMaxLength') }}</div>
              </div>
            </div>

            <!-- Action Button -->
            <div class="col-12 mb-3">
              <button type="button" class="btn btn-outline-danger btn-sm w-100" (click)="removeWorkRow(i)" [disabled]="workExperienceFormArray.length === 1">
                <i class="fas fa-trash me-1"></i>{{ getTranslation('educationWork.removeWorkExperience') }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="add-row-section" *ngIf="!isPreviewMode">
        <button type="button" class="btn btn-primary btn-sm" 
                (click)="addWorkRow()" 
                [disabled]="!isLastWorkRowComplete() || hasWorkYearValidationErrors()"
                [title]="getWorkAddButtonTooltip()">
          <i class="fas fa-plus"></i> {{ getTranslation('educationWork.addWorkExperience') }}
        </button>
      </div>

      <!-- Validation Error for Work Experience -->
      <div *ngIf="submitted && educationaAndworkExperienceForm.get('HasWorkExperience')?.value === 'Yes' && !hasValidWorkData()" class="validation-error">
        <i class="fas fa-exclamation-triangle"></i>
        {{ getTranslation('educationWork.atLeastOneWorkRequired') }}
      </div>
    </div>

    <!-- Buttons start -->


    <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode && isEditable">
      <button type="button" class="btn savedraftbtn" 
              *ngIf="educationaAndworkExperienceForm.get('SaveMode')?.value !== SaveMode.SAVE"
              (click)="onSubmit(SaveMode.DRAFT)">
        <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
      </button>
      <button type="button" class="btn prevbtn" (click)="goToBack()">
        <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
      </button>
      <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
        <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
      </button>
  </div>
    <!-- Buttons ends -->
  </form>
</div>

